// firebase.js

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ✅ Firebase Config
const firebaseConfig = {
    apiKey: "AIzaSyCC3EylonkQvtFAyhOhHk2CYbmP32mBOT4",
    authDomain: "geneartai.firebaseapp.com",
    projectId: "geneartai",
    storageBucket: "geneartai.firebasestorage.app",
    messagingSenderId: "1034798863224",
    appId: "1:1034798863224:web:95a03fb8f47c38f5912e8d",
    measurementId: "G-TFG7Y2KF5W"
};

// ✅ Config Validator
const requiredKeys = ["apiKey", "authDomain", "projectId", "storageBucket", "messagingSenderId", "appId"];
requiredKeys.forEach((key) => {
    if (!firebaseConfig[key]) {
        console.warn(`⚠️ Missing Firebase config key: ${key}`);
    }
});

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);

export default app;
